export default __webpack_public_path__ + "9b52daef9a86de95741d4a81cd743425.png";